import React from "react"
import Icon from "@kit/design/icon"

export const createIcon = (icon, props) => <Icon name={icon} {...props} />

const defaultIcons = {
  alignCenter: createIcon("center-align"),
  alignJustify: createIcon("paragraph-justified-align"),
  alignLeft: createIcon("left-align"),
  alignRight: createIcon("right-align"),
  blockquote: createIcon("quote"),
  bold: createIcon("text-bold"),
  bolt: createIcon("bolt"),
  button: createIcon("button"),
  color: createIcon("drop"),
  down: createIcon("down"),
  file: createIcon("file"),
  fontSize: createIcon("text-size"),
  headingOne: createIcon("heading-1"),
  headingTwo: createIcon("heading-2"),
  headingThree: createIcon("heading-3"),
  headingFour: createIcon("heading-4"),
  headingFive: createIcon("heading-5"),
  headingSix: createIcon("heading-6"),
  horizontalRule: createIcon("line"),
  html: createIcon("code-file"),
  image: createIcon("image"),
  captionedImage: createIcon("image"),
  images: createIcon("image-gallery"),
  instagram: createIcon("instagram"),
  italic: createIcon("text-italic"),
  link: createIcon("link"),
  newsletter: createIcon("newspaper"),
  orderedList: createIcon("ordered-list"),
  paragraph: createIcon("paragraph"),
  personalization: createIcon("email-address"),
  plus: createIcon("plus-circle"),
  product: createIcon("bag"),
  quote: createIcon("quote"),
  share: createIcon("share"),
  snippet: createIcon("grip-lines"),
  stopwatch: createIcon("stopwatch"),
  strikethrough: createIcon("text-strikethrough"),
  underline: createIcon("text-underline"),
  unorderedList: createIcon("unordered-list"),
  video: createIcon("video")
}

export const fetchIcon = icon => {
  if (typeof icon === "string") {
    if (!Object.keys(defaultIcons).includes(icon)) {
      console.warn(
        `The specified icon "${icon}" does not exist in the icons object`
      )
      return ""
    }
    return defaultIcons[icon]
  }
}
